import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download, Zap } from 'lucide-react';
export function Closing() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-white py-24 px-6 text-center" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <FadeIn data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-green mb-4" data-id="element-75">
            ESTA PUEDE SER LA DIFERENCIA ENTRE SEGUIR IGUAL… O EMPEZAR A
            ENTENDER CÓMO GENERAR INGRESOS DESDE CASA
          </h2>

          <div className="space-y-2 mb-6" data-id="element-76">
            <p className="text-lg text-brand-text/70" data-id="element-77">
              No necesitas saberlo todo.
            </p>
            <p className="text-lg text-brand-text/70" data-id="element-78">
              No necesitas experiencia.
            </p>
            <p className="text-lg text-brand-green font-semibold" data-id="element-79">
              Solo necesitas empezar con la guía correcta.
            </p>
          </div>

          <p className="text-lg text-brand-text/70 mb-6" data-id="element-80">
            Este sistema está diseñado para mostrarte paso a paso cómo usar
            Amazon Seller y evitar los errores que hacen que la mayoría
            abandone.
          </p>

          <div className="bg-brand-beige/50 p-5 rounded-xl mb-6 border border-brand-gold/20 inline-block" data-id="element-81">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-brand-text font-medium" data-id="element-82">
              <span data-id="element-83">✔️ Claridad desde el inicio</span>
              <span data-id="element-84">✔️ Proceso simple y directo</span>
              <span data-id="element-85">✔️ Acceso inmediato</span>
            </div>
          </div>

          <p className="text-lg text-brand-text/60 italic mb-4" data-id="element-86">
            Cada día que pasa, es un día más sin avanzar.
          </p>
          <p className="text-xl text-brand-green font-bold mb-12" data-id="element-87">
            HAZ CLIC AHORA Y EMPIEZA HOY MISMO
          </p>

          <Button onClick={goToCheckout} className="text-lg px-12 py-5" data-id="element-88">
            QUIERO ACCESO INMEDIATO AHORA
          </Button>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-89">
            <span className="flex items-center gap-1.5" data-id="element-90">
              <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-91" />
              ACCESO INMEDIATO
            </span>
            <span className="flex items-center gap-1.5" data-id="element-92">
              <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-93" />
              DESCARGA DIGITAL
            </span>
            <span className="flex items-center gap-1.5" data-id="element-94">
              <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-95" />
              COMPRA SEGURA
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}